export const state = {
    yearSelected: new Date().getFullYear(),
    accident: 3,
    collision: 4,
}